async function fetchApplyDiscount({ uid, discount, productId, productType }) {
  const API = `https://us-central1-auto-clupp.cloudfunctions.net/cluppAPIV1/v1/users/${uid}/apply-discount`;

  const url = new URL(API);
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJvcmdhbml6YXRpb24iOiJSQVNUUkVBVE9SIn0.OGp_G6Lref09-YkoRsY3vBUEndMpAbhUR-tHHu-nlm4",
      },
      body: JSON.stringify({
        productId,
        productType,
      }),
    });
    
    const json = await response.json();
    
    if (!json.success) {
      console.log("[Error aplling discount]", json);
      throw new Error("Error aplling discount");
    }

    return json;
  } catch (error) {
    console.log("[Error aplling discount]", error);
    throw new Error("Error aplling discount");
  }
}

export default fetchApplyDiscount;
